import { combineReducers } from "@reduxjs/toolkit"

// Front
import Layout from "./layout/layoutSlice"

// Authentication
import Login from "./auth/login/loginSlice"
import Account from "./auth/register/registerSlice"
import ForgetPassword from "./auth/forgetpwd/forgetpwdSlice"
import Profile from "./auth/profile/profileSlice"
import ProfileStatus from "./auth/profile/profileStatusSlice"
import Agents from "./auth/agent/agentSlice"
import Subscription from "./auth/subscription/subscriptionSlice"

//Calendar
import calendar from "./calendar/calendarSlice"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ProfileStatus,
  calendar,
  Agents,
  Subscription,
})

export default rootReducer
